import React from 'react';

const Wrapper = (props) => <div className="wrapper">{props.children}</div>;

export default Wrapper;
